import React from "react";
import { philosophy, homepagePositioning } from "../mock";

const Philosophy = () => {
  return (
    <section id="philosophy" className="relative py-28 md:py-36 cosmic-panel overflow-hidden">
      <div className="stars opacity-70" />
      <div className="pointer-events-none absolute top-20 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full border border-[#D4A85B]/10 animate-orbit-slow" />
      <div className="pointer-events-none absolute top-40 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full border border-[#D4A85B]/15" />

      <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
        <div className="divider-star justify-center">
          <span>{philosophy.eyebrow}</span>
        </div>

        <div className="mt-10 space-y-5">
          {philosophy.lines.map((l, i) => (
            <div
              key={i}
              className="font-serif text-[34px] md:text-[54px] leading-[1.08] text-[#EDE3D0]"
            >
              {l.text}{" "}
              <em className="not-italic italic font-serif text-[#D4A85B]">{l.accent}</em>
            </div>
          ))}
        </div>

        <div className="mt-16 max-w-3xl mx-auto space-y-5 text-[#EDE3D0]/80 leading-relaxed">
          {homepagePositioning.map((p, i) => (
            <p key={i} className={i === 3 ? "font-serif text-[#D4A85B] text-xl italic" : ""}>
              {p}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
